import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "chart-values" }

import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import formRulesGenerator from '@shell/utils/validators/formRules';
import Checkbox from '@components/Form/Checkbox/Checkbox.vue';
import LabeledSelect from '@shell/components/form/LabeledSelect.vue';
import LabeledInput from '@components/Form/LabeledInput/LabeledInput.vue';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartValues',
  props: {
    chart: {},
    value: {},
    title: {},
    mode: {},
    disabled: { type: Boolean }
  },
  emits: ['valid'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emit function
const emit = __emit;

// Store
const store = useStore();

// Reactive data
const valid = ref<{ [key: string]: boolean }>({});

// Watch for changes in `valid`
watch(valid, (newValid) => {
  emit('valid', newValid);
});

// Methods
const rules = (key: string, min: any, max: any) => {
  const frg = formRulesGenerator(store.getters['i18n/t'], { key });
  const minRule = frg.minValue(min);
  const maxRule = frg.maxValue(max);

  return (value: string) => {
    const messages = [];

    if (value) {
      const minRes = minRule(value);
      if (minRes) messages.push(minRes);

      const maxRes = maxRule(value);
      if (maxRes) messages.push(maxRes);
    }

    valid.value[key] = !messages.length;
    return messages.join(',');
  };
};

const numericPlaceholder = (setting: any) => {
  if (setting.maximum && setting.minimum) {
    return `${setting.minimum} to ${setting.maximum}`;
  } else if (setting.maximum) {
    return `<= ${setting.maximum}`;
  } else if (setting.minimum) {
    return `>= ${setting.minimum}`;
  } else {
    return '';
  }
};

const onInputCheckbox = (key: string, value: boolean) => {
  props.value[key] = value ? 'true' : 'false';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(props.title), 1),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.chart, (setting, key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "chart-values-item"
      }, [
        (setting.type === 'number' || setting.type === 'integer')
          ? (_openBlock(), _createBlock(LabeledInput, {
              key: 0,
              id: key,
              value: props.value[key],
              "onUpdate:value": ($event: any) => ((props.value[key]) = $event),
              label: key,
              type: "number",
              min: setting.minimum,
              max: setting.maximum,
              rules: [rules(key, setting.minimum, setting.maximum)],
              tooltip: numericPlaceholder(setting),
              mode: props.mode,
              disabled: props.disabled
            }, null, 8, ["id", "value", "onUpdate:value", "label", "min", "max", "rules", "tooltip", "mode", "disabled"]))
          : (setting.type === 'bool')
            ? (_openBlock(), _createBlock(Checkbox, {
                key: 1,
                id: key,
                value: props.value[key] === 'true',
                label: key,
                mode: props.mode,
                disabled: props.disabled,
                "onUpdate:value": ($event: any) => (onInputCheckbox(key, $event))
              }, null, 8, ["id", "value", "label", "mode", "disabled", "onUpdate:value"]))
            : (setting.type === 'string' && setting.enum)
              ? (_openBlock(), _createBlock(LabeledSelect, {
                  key: 2,
                  id: key,
                  value: props.value[key],
                  "onUpdate:value": ($event: any) => ((props.value[key]) = $event),
                  label: key,
                  options: setting.enum,
                  mode: props.mode,
                  disabled: props.disabled
                }, null, 8, ["id", "value", "onUpdate:value", "label", "options", "mode", "disabled"]))
              : (setting.type === 'string')
                ? (_openBlock(), _createBlock(LabeledInput, {
                    key: 3,
                    id: key,
                    value: props.value[key],
                    "onUpdate:value": ($event: any) => ((props.value[key]) = $event),
                    label: key,
                    mode: props.mode,
                    disabled: props.disabled
                  }, null, 8, ["id", "value", "onUpdate:value", "label", "mode", "disabled"]))
                : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})